<template>
    <div>
        <div 
            v-if="offline"
            class="tickets-details-offline-header"
        >
            Offline Mode
        </div>
        <v-container id="tickets-details-page">
            <v-row v-if="getTicketDetails">
                <!-- Page Header -->
                <v-col
                    class="col col-md-12"
                    style="padding: 12px 0px;"
                >
                    <v-toolbar flat>
                        <div class="d-flex justify-space-between align-center">
                            <v-btn
                                icon
                                class="btn-back"
                                @click="backTicketList()"
                            >
                                <v-icon class="material-icons-outlined">
                                    chevron_left
                                </v-icon>
                            </v-btn>
                            <v-toolbar-title
                                class="pl-3"
                            >
                                {{ formatTicketNumber(getTicketDetails.Tickets.ticket, getTicketDetails.Tickets.revision) }}
                            </v-toolbar-title>
                            <v-chip
                                link
                                outlined
                                pill
                                class="ml-5"
                                :class="ticketStatus[getTicketDetails.Ticket_Status.stage] ? ticketStatus[getTicketDetails.Ticket_Status.stage].class : ''"
                            >
                                {{ ticketStatus[getTicketDetails.Ticket_Status.stage] ? ticketStatus[getTicketDetails.Ticket_Status.stage].status : '' }}
                            </v-chip>
                            <v-chip
                                v-if="getTicketDetails.Ticket_Status.cancelled"
                                class="ml-5"
                            >
                                CANCELLED
                            </v-chip>
                            <!-- CWTM-639 hide clipboard icon
                            <v-icon
                                v-if="!offline"
                                class="ml-3"
                            >
                                bookmark_border
                            </v-icon> -->
                        </div>
                        <div
                            v-if="!$vuetify.breakpoint.mdAndDown"
                            class="d-flex justify-space-between align-center"
                        >
                            <TicketDetailsIcons 
                                @open-reopen-dialog="reopen"
                            />
                            <TicketDetailsButtons
                                @open-respond-dialog="respond"
                                @open-assign-dialog="assign"
                            />
                            <v-btn
                                :disabled="!selectedTicketText"
                                class="action-btn text-subtitle-2"
                                depressed
                                color="primary"
                                @click="printCopy"
                            >
                                <v-icon
                                    left
                                    dark
                                    class="material-icons-outlined action-icon"
                                >
                                    print
                                </v-icon>
                                Print
                                <v-icon
                                    right
                                    dark
                                    size="x-small"
                                    class="material-icons-outlined action-icon"
                                >
                                    open_in_new
                                </v-icon>
                            </v-btn>
                        </div>
                    </v-toolbar>
                </v-col>
            </v-row>
            <v-row v-if="getTicketDetails">
                <v-chip
                    v-if="getTicketDetails.Tickets.center"
                    label
                    outlined
                    class="ml-2"
                >
                    {{ getTicketDetails.Tickets.center }}
                </v-chip>
                <v-chip
                    v-if="getTicketDetails.Tickets.priority"
                    label
                    outlined
                    class="ml-2"
                >
                    <v-icon
                        small
                        class="mr-1"
                    >
                        info
                    </v-icon>
                    {{ getTicketDetails.Tickets.priority }}
                </v-chip>
                <v-chip
                    v-if="getTicketDetails.Tickets.type"
                    label
                    outlined
                    class="ml-2"
                >
                    {{ getTicketDetails.Tickets.type }}
                </v-chip>
                <v-chip
                    v-if="getTicketDetails.Tickets.category"
                    label
                    outlined
                    class="ml-2"
                >
                    {{ getTicketDetails.Tickets.category }}
                </v-chip>
                <v-chip
                    v-if="getTicketDetails.Tickets.duedate"
                    label
                    outlined
                    class="ml-2"
                >
                    {{ dueDateText(getTicketDetails.Tickets.duedate) }}
                </v-chip>
            </v-row>
            <v-row v-if="getTicketDetails">
                <v-divider class="my-3" />
            </v-row>
            <v-row
                v-if="getTicketDetails"
                class="my-5 d-flex flex-column"
                :class="$vuetify.breakpoint.mobile ? 'mx-1' : 'mx-5'"
            >
                <div class="d-flex justify-space-between align-center">
                    <h4>
                        Overview
                    </h4>
                    <div class="d-flex align-center">
                        <TicketDetailsIcons
                            v-if="$vuetify.breakpoint.mdAndDown" 
                            @open-reopen-dialog="reopen"
                        />
                        <TicketDetailsButtons
                            v-if="$vuetify.breakpoint.mdAndDown && !$vuetify.breakpoint.xs"
                            @open-respond-dialog="respond"
                            @open-assign-dialog="assign"
                        />
                        <v-btn
                            v-if="$vuetify.breakpoint.mdAndDown && !$vuetify.breakpoint.xs"
                            :disabled="!selectedTicketText"
                            class="action-btn text-subtitle-2"
                            depressed
                            color="primary"
                            @click="printCopy"
                        >
                            <v-icon
                                left
                                dark
                                class="material-icons-outlined action-icon"
                            >
                                print
                            </v-icon>
                            Print
                            <v-icon
                                right
                                dark
                                size="x-small"
                                class="material-icons-outlined action-icon"
                            >
                                open_in_new
                            </v-icon>
                        </v-btn>
                    </div>
                </div>
                <table class="custom-data-table">
                    <tbody>
                        <tr v-if="getTicketDetails.Ticket_Status.cancelled">
                            <td />
                            <td style="color: red; font-weight: bold;">
                                THIS TICKET HAS BEEN CANCELLED
                            </td>
                        </tr>
                        <tr v-if="this.$store.getters.user.ingroup === 'SYSOP'">
                            <td>tid</td>
                            <td>{{ showTid() }}</td>
                        </tr>
                        <tr v-if="getTicketDetails.Tickets.old_ticket.length">
                            <td>Previous Ticket: </td>
                            <td>
                                <b v-if="getTicketDetails.Tickets.old_ticket_tid">
                                    
                                    <a :href="'/#/tickets/details?tid=' + encodeURIComponent(guidNormal(getTicketDetails.Tickets.old_ticket_tid))">
                                        {{ getTicketDetails.Tickets.old_ticket }}
                                    </a>
                                </b>
                                <b v-else>
                                    {{ getTicketDetails.Tickets.old_ticket }}
                                    <span style="color: gray;">&nbsp; &laquo;Not Found&raquo;</span>
                                </b>
                            </td>
                        </tr>
                        <tr v-if="getTicketDetails.Ticket_Status.ticket_new.length">
                            <td>New Ticket: </td>
                            <td>
                                <b v-if="getTicketDetails.Ticket_Status.ticket_new_tid">
                                    <a :href="'/#/tickets/details?tid=' + encodeURIComponent(guidNormal(getTicketDetails.Tickets.old_ticket_tid))">
                                        {{ getTicketDetails.Ticket_Status.ticket_new }}
                                    </a>
                                </b>
                                <b v-else>
                                    {{ getTicketDetails.Ticket_Status.ticket_new }}
                                    <span style="color: gray;">&nbsp; &laquo;Not Found&raquo;</span>
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td>Company Name: </td>
                            <td><b>{{ getTicketDetails.Tickets.company }}</b></td>
                        </tr>
                        <tr>
                            <td>Site Contact: </td>
                            <td><b> {{ getTicketDetails.Tickets.contact_name != "" ? getTicketDetails.Tickets.contact_name: getTicketDetails.Tickets.caller }}</b></td>
                        </tr>
                        <tr>
                            <td>Site Phone : </td>
                            <td><b>{{ getTicketDetails.Tickets.contact_phone ? formatPhone(getTicketDetails.Tickets.contact_phone) : formatPhone(getTicketDetails.Tickets.caller_phone) }}</b></td>
                        </tr>
                        <tr>
                            <td>Site SMS/Cell : </td>
                            <td><b>{{ getTicketDetails.Tickets.contact_phone_alt ? getTicketDetails.Tickets.contact_phone_alt: emptyString }}</b></td>
                        </tr>
                        <tr>
                            <td>Work Type : </td>
                            <td><b>{{ getTicketDetails.Tickets.work_type }}</b></td>
                        </tr>
                        <tr>
                            <td>Additional : </td>
                            <td>
                                <div>
                                    <v-chip
                                        v-if="showExplosives(getTicketDetails.Tickets.explosives)" 
                                        pill
                                        outlined
                                        :color="getExplosivesColor(getTicketDetails.Tickets.explosives)"
                                        class="detail-chip"
                                    >
                                        Explosives
                                    </v-chip>
                                    <v-chip
                                        v-if="showBoring(getTicketDetails.Tickets.boring)"
                                        pill
                                        outlined
                                        :color="
                                            getBoringColor(getTicketDetails.Tickets.boring)"
                                        class="detail-chip"
                                    >
                                        Boring
                                    </v-chip>                                    
                                    <v-chip
                                        v-if="showVacuum(getTicketDetails.Tickets.vacuum)" 
                                        outlined
                                        :color="getVacuumColor(getTicketDetails.Tickets.vacuum)"
                                        class="detail-chip"
                                    >
                                        Vacuum
                                    </v-chip>                                   
                                    <v-chip
                                        v-if="showPremarked(getTicketDetails.Tickets.delineated, getTicketDetails.Tickets.whitelined)" 
                                        pill
                                        outlined
                                        :color="getPremarkedColor(getTicketDetails.Tickets.delineated)"                                   
                                        class="detail-chip"
                                    >
                                        Pre-Marked
                                    </v-chip>
                                    <v-chip
                                        v-if="showMeet(getTicketDetails.Tickets.meet)" 
                                        pill
                                        outlined
                                        :color="getMeetColor(getTicketDetails.Tickets.meet)"
                                        class="detail-chip"
                                    >
                                        Meet
                                    </v-chip>                                  
                                    <v-chip
                                        v-if="showLegal(getTicketDetails.Tickets.legal)" 
                                        pill
                                        outlined
                                        :color="getLegalColor(getTicketDetails.Tickets.legal)"
                                        class="detail-chip"
                                    >
                                        Legal
                                    </v-chip> 
                                    <v-chip
                                        v-if="showRemark(getTicketDetails.Tickets.remark)" 
                                        pill
                                        outlined
                                        :color="getRemarkColor(getTicketDetails.Tickets.remark)"
                                        class="detail-chip"
                                    >
                                        Re-Mark
                                    </v-chip>
                                    <v-chip
                                        v-if="showExtendedJob(getTicketDetails.Tickets.extended_job)" 
                                        pill
                                        outlined
                                        :color="getExtendedJobColor(getTicketDetails.Tickets.extended_job)"
                                        class="detail-chip"
                                    >
                                        Extended Job
                                    </v-chip>
                                    <v-chip
                                        v-if="showNight(getTicketDetails.Tickets.night)" 
                                        pill
                                        outlined
                                        :color="getNightColor(getTicketDetails.Tickets.night)"
                                        class="detail-chip"
                                    >
                                        Night
                                    </v-chip>
                                    <v-chip
                                        v-if="showWeekend(getTicketDetails.Tickets.weekend)" 
                                        pill
                                        outlined
                                        :color="getWeekendColor(getTicketDetails.Tickets.weekend)"
                                        class="detail-chip"
                                    >
                                        Weekend
                                    </v-chip>
                                    <v-chip
                                        v-if="showExcavStSidewalk(getTicketDetails.Tickets.excav_st_sidewalk)" 
                                        pill
                                        outlined
                                        :color="getExcavStSidewalkColor(getTicketDetails.Tickets.excav_st_sidewalk)"
                                        class="detail-chip"
                                    >
                                        St/Sidewalk
                                    </v-chip>
                                    <v-chip
                                        v-if="showDigInRoad(getTicketDetails.Tickets.dig_in_road)" 
                                        pill
                                        outlined
                                        :color="getDigInRoadColor(getTicketDetails.Tickets.dig_in_road)"
                                        class="ma-1 detail-chip"
                                    >
                                        Dig In Road
                                    </v-chip>
                                    <v-chip
                                        v-if="showOneYear(getTicketDetails.Tickets.one_year)" 
                                        pill
                                        outlined
                                        :color="getOneYearColor(getTicketDetails.Tickets.one_year)"
                                        class="ml-1 detail-chip"
                                    >
                                        1 Year
                                    </v-chip>
                                    <v-chip
                                        v-if="showRailroad(getTicketDetails.Tickets.railroad)" 
                                        pill
                                        outlined
                                        :color="getRailroadColor(getTicketDetails.Tickets.railroad)"
                                        class="ml-1 detail-chip"
                                    >
                                        Railroad
                                    </v-chip>
                                </div>
                            </td>                     
                        </tr>
                        <tr>
                            <td>Done For : </td>
                            <td><b>{{ getTicketDetails.Tickets.donefor }}</b></td>
                        </tr>
                        <tr>
                            <td>Address : </td>
                            <td><b>{{ getTicketDetails.Tickets.full_address }}</b></td>
                        </tr>
                        <tr>
                            <td>Location : </td>
                            <td><b>{{ getTicketDetails.Tickets.location }}</b></td>
                        </tr>
                        <tr>
                            <td>Due Date : </td>
                            <td><b>{{ formateDate(getTicketDetails.Tickets.duedate) }}</b></td>
                        </tr>
                        <tr>
                            <td>Work Date : </td>
                            <td><b>{{ formateDate(getTicketDetails.Tickets.work_date) }}</b></td>
                        </tr>
                        <tr v-if="getTicketDetails.Tickets.work_end_date && getTicketDetails.Tickets.work_end_date.length">
                            <td>Work Ends : </td>
                            <td><b>{{ formateDate(getTicketDetails.Tickets.work_end_date) }}</b></td>
                        </tr>
                        <tr v-if="getTicketDetails.Tickets.comments">
                            <td>Comments : </td>
                            <td><b>{{ getTicketDetails.Tickets.comments }}</b></td>
                        </tr>
                        <tr>
                            <td>Remarks : </td>
                            <td><b v-html="getRemarksHTML"></b></td>
                        </tr>
                    </tbody>
                </table>            
            </v-row>       
            <v-row
                v-if="getTicketDetails"
                :style="{'margin-bottom': $vuetify.breakpoint.xs ? '80px' : ''}"
            >
                <v-expansion-panels
                    v-model="openedPanels"
                    :multiple="multipleOpenedPanelsAllowed"
                    :style="{'z-index': $vuetify.breakpoint.xs ? '6' : '1'}"
                    @change="onChangeExpansionPanel"
                >
                    <draggable
                        :list="getLayoutOrder"
                        ghost-class="ghost"
                        :options="{ disabled : (openedPanels === null || ((Array.isArray(openedPanels) && openedPanels.length > 0))), delay: 300, delayOnTouchOnly: true }"
                        @change="updateOrder($event, getLayoutOrder)"
                    >
                        <v-expansion-panel
                            v-for="(item) in getLayoutOrder"
                            :key="item"
                        >
                            <v-expansion-panel-header>
                                <DragIcon style="cursor: move;" />
                                <span class="expansion-title">{{ updateExpansionListCount[item].name }}</span>
                                <v-chip
                                    v-if="updateExpansionListCount[item].hasCount"
                                    class="ml-2 text-caption detail-chip"
                                    outlined
                                >
                                    {{ updateExpansionListCount[item].count }}
                                </v-chip>
                                <template v-slot:actions>
                                    <v-icon
                                        v-if="!$vuetify.breakpoint.xs"
                                        color="primary"
                                    >
                                        expand_more
                                    </v-icon>
                                    <v-icon
                                        v-if="$vuetify.breakpoint.xs"
                                        color="primary"
                                    >
                                        chevron_right
                                    </v-icon>
                                </template>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content :class="$vuetify.breakpoint.xs ? 'expandable-mobile-view' : ''">
                                <v-card
                                    v-if="$vuetify.breakpoint.xs"
                                    elevation="0"
                                    class="mobile-view-header"
                                >
                                    <v-btn
                                        icon
                                        class="btn-back"
                                        @click="closeAllPanels"
                                    >
                                        <v-icon class="material-icons-outlined">
                                            chevron_left
                                        </v-icon>
                                    </v-btn>
                                    <h4>{{ updateExpansionListCount[item].name }}</h4>
                                    <v-chip
                                        v-if="updateExpansionListCount[item].hasCount"
                                        class="ml-2 text-caption detail-chip"
                                        outlined
                                    >
                                        {{ updateExpansionListCount[item].count }}
                                    </v-chip>
                                </v-card>
                                <RevisionsList v-if="item===1" />
                                <Responses
                                    v-if="item===2"
                                    :ticket-details="getTicketDetails"
                                    @update-ticket-details="loadTicketDetails"
                                    @offline-response-success="offlineResponseSuccess"
                                />
                                <originalTicket
                                    v-if="item===3"
                                    :ticket-details="getTicketDetails"
                                    @update-selected-ticket-text="updateSelectedTicketText"
                                />
                                <Map v-if="item===4" />
                                <Images
                                    v-if="item===5"
                                    @reloadTicketDetails="loadTicketDetails"
                                />
                                <Notes
                                    v-if="item===6"
                                    @load-ticket-details="loadTicketDetails"
                                />
                                <History v-if="item===7" />
                                <ReportsComponent v-if="item===8" />
                                <ResponseHistory v-if="item===9" />
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </draggable>
                </v-expansion-panels>
            </v-row>

            <div
                v-if="!getTicketDetails"
                class="d-flex justify-center align-center w-100p"
                style="height: 90vh;"
            >
                <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                />
            </div>
            <div
                v-if="$vuetify.breakpoint.xs && (openedPanels === null || (Array.isArray(openedPanels) && openedPanels.length === 0))"
                class="mobile-footer-controls"
                :class="offline ? 'offline' : ''"
            >
                <TicketDetailsButtons 
                    @open-respond-dialog="respond"
                    @open-assign-dialog="assign"
                />
            </div>
            <TicketsReOpenDialog
                :selected-tickets="actionTickets"
                :show="showTicketsReopenDialog"
                @close-reopen-dialog="closeReopen"
                @reopen-success="reopenSuccess"
            />
            <TicketsResponseDialog
                :selected-tickets="actionTickets"
                :show="showTicketsResponseDialog"
                @close-response-dialog="closeRespond"
                @reponse-success="responseSuccess"
                @offline-reponse-success="offlineResponseSuccess"
            />
            <TicketResponseErrorDialog
                :show="showRespondError"
                :respond-result="respondResult"
                @close-response-error-dialog="closeRespondErrorDialog"
            />
            <TicketsAssignDialog
                :selected-tickets="actionTickets"
                :show="showTicketsAssignDialog"
                :select-all-members="true"
                @close-assign-dialog="closeAssign"
                @assign-success="assignSuccess"
            />
            <OfflineResponseToast
                :show-response-toast="showResponseToast"
                @close-offline-response-toast="showResponseToast = false" 
            />
        </v-container>
    </div>
</template>
<script>
import linkifyHtml from 'linkify-html';
import webtmsBackend from '@/services/webtmsBackend';
import moment from 'moment';
import draggable from 'vuedraggable';

import DragIcon from '@/components/CustomIcons/DragIcon';
import RevisionsList from './RevisionsList.vue';
import Responses from './Responses.vue';
import originalTicket from './originalTicket.vue';
import Map from './Map.vue';
import Images from './Images.vue';
import Notes from './Notes.vue';
import History from './History.vue';
import ReportsComponent from './ReportsComponent.vue';
import ResponseHistory from './ResponseHistory.vue';

import TicketDetailsIcons from './TicketDetailsIcons.vue';
import TicketDetailsButtons from './TicketDetailsButtons.vue';
import TicketsReOpenDialog from '../TicketsReOpenDialog.vue';
import TicketsResponseDialog from '../TicketsResponseDialog.vue';
import TicketsAssignDialog from '../TicketsAssignDialog.vue';
import OfflineResponseToast from '../Offline/OfflineResponseToast';
import TicketResponseErrorDialog from '../ErrorDialogs/TicketRespondErrorDialog.vue';
import { formatPhone } from '@/utils/phone';
import { formatTicketNumber } from '@/utils/formatTicketNumber.js';
import { guidEqual, guidNormal } from '@/utils/guid.js';
import { htmlEncode } from '@/utils/encoding.js';

export default {
    beforeRouteEnter(to, from, next) {
        // console.log('beforeRouteEnter', to, from, next);
        next(vm => {
            vm.loadTicketDetails();
        });
    },
    beforeRouteUpdate(to) {
        // console.log('*** beforeRouteUpdate'); // , to, from, next
        // console.log('                from =' + from.fullPath);
        // console.log('                  to = ' + to.fullPath);
        // console.log('    $route.query.tid = ' + this.$route.query.tid);
        // If we are staying in this same component but switching tickets, 
        // grab the new tid and reload for that.
        if(to.fullPath.startsWith('/tickets/details?tid=')) {
            const tid = to.fullPath.split('=')[1];
            this.$route.query.tid = tid;  // don't think this is in the docs, but it works
            this.loadTicketDetails();
        }
    },
    components: {
        draggable,
        DragIcon,
        RevisionsList,
        Responses,
        originalTicket,
        Map,
        Images,
        Notes,
        History,
        ReportsComponent,
        ResponseHistory,
        TicketDetailsIcons,
        TicketDetailsButtons,
        TicketsReOpenDialog,
        TicketsResponseDialog,
        TicketsAssignDialog,
        OfflineResponseToast,
        TicketResponseErrorDialog,
    },
    data: () => ({
        openedPanels: [],
        ticketStatus: {
            IL: { status: 'INITIAL LOADING', class: 'ticket-status-loading' },
            GC: { status: 'LOADING (Geocoding)', class: 'ticket-status-loading' },
            AC: { status: 'LOADING (Auto-Respond)', class: 'ticket-status-loading' },
            AA: { status: 'LOADING (Auto-Assign)', class: 'ticket-status-loading' },
            OP: { status: 'OPEN', class: 'ticket-status-open' },
            CT: { status: 'CLOSED', class: 'ticket-status-closed' },
        },
        expansionList: [
            {
                id: 1,
                name: 'Revisions',
                key: 'revisions',
                count: 0,
                hasCount: true,
            },
            {
                id: 2,
                name: 'Responses',
                key: 'Ticket_Responses',
                count: 0,
                hasCount: true,
            },
            {
                id: 3,
                name: 'Original Ticket',
                count: 0
            },
            {
                id: 4,
                name: 'Map',
                count: 0
            },
            {
                id: 5,
                name: 'Attachments and Images',
                key: 'Ticket_Images',
                count: 0,
                hasCount: true,
            },
            {
                id: 6,
                name: 'Notes',
                key: 'Ticket_Notes',
                count: 0,
                hasCount: true,
            },
            {
                id: 7,
                name: 'History',
                key: 'Ticket_History',
                count: 0,
                hasCount: true,
            },
            {
                id: 8,
                name: 'Reports',
                key: 'Ticket_Reports',
                count: 0,
                hasCount: true,
            },
            {
                id: 9,
                name: 'Center/811 +Response History',
                key: 'Ticket_PositiveResponseLog',
                count: 0,
                hasCount: true,
            },
        ],
        showTicketsReopenDialog: false,
        showTicketsResponseDialog: false,
        showTicketsAssignDialog: false,
        showResponseToast: false,
        respondResult: {},
        showRespondError: false,
        emptyString: 'NOT PROVIDED',
        default_color: 'green',
        selectedTicketText: null
    }),
    
    computed: {
        multipleOpenedPanelsAllowed() {
            return !this.$vuetify.breakpoint.xs;
        },
        offline() {
            return this.$store.getters.forceOffline;
        },
        actionTickets() {
            let actionTickets = [];
            let details = this.getTicketDetails;
            let responses = details?.Ticket_Responses || [];
            for(let response of responses) {
                let actionTicket = Object.assign({}, details.Tickets);
                let ticketStatus = details.Ticket_Status;
                for(let key in ticketStatus) {
                    actionTicket['TS_'+key] = ticketStatus[key];
                }
                for(let key in response) {
                    actionTicket['TR_'+key] = response[key];
                }
                actionTickets.push(actionTicket);
            }
            return actionTickets;
        },
        getTicketDetails() {
            return this.$store.getters.ticketDetails;
        },
        getUserOptions() {
            return this.$store.getters.userOptions;
        },
        getLayoutOrder() {
            let layout = this.getUserOptions.find(item => item.option === 'UI:TICKET_DETAIL_LAYOUT_ORDER');
            if(layout && layout.value && layout.value.length) {
                layout = layout.value.split(',');
                layout = layout.map(item=>Number(item)).filter(item=>item);
                return layout;
            } else {
                return [1, 2, 3, 4, 5, 6, 7, 8, 9];
            }
        },
        getLayoutState() {
            const reCSVDigits = /\d[,\d]*/;
            let layout = this.getUserOptions.find(item => item.option === 'UI:TICKET_DETAIL_LAYOUT_STATE');
            if(layout && reCSVDigits.test(layout.value)) {
                layout = layout.value.split(',');
                layout = layout.map(item=>Number(item)).filter(i => !isNaN(i) && i >= 0 && i < 10);
                return layout; // array of integers each in [0,9]
            } else {
                return [];
            }
        },
        updateExpansionListCount() {
            let updateExpansionList = {};
            this.expansionList.map((item) => {
                if(item.key) {
                    item.count = this.getTicketDetails[item.key].length;
                }
                updateExpansionList[item.id] = item;
            });
            return updateExpansionList;
        },
        getRemarksHTML() {
            if(!this.getTicketDetails.Tickets.remarks) {
                return 'No Remarks';
            }   
            return linkifyHtml(this.getTicketDetails.Tickets.remarks);
        },
    },
    mounted() {
        this.$nextTick(() => {
            if(this.$vuetify.breakpoint.xs) {
                this.openedPanels = null;
            } else {
                this.openedPanels = this.getLayoutState; // v-expansion-panel closed/expanded state
            }
        });
    },
    methods: {
        guidNormal,
        showTid() {
            var cleanGuid = function(guid) {
                if(guid) {
                    return guid.toLowerCase().replace(/[{}]/g, '');
                } else {
                    return guid;
                }
            };
            let v1 = cleanGuid(this.getTicketDetails.Tickets.tid);
            let v2 = cleanGuid(this.$route.query.tid);
            if(v1 == v2) {
                return v1;
            } else {
                return v1 + ' !== Route: ' + v2;
            }
        },
        async loadTicketDetails() {
            this.$store.commit('SET_TICKET_DETAILS', null); // clear previous ticket details
            let ticketDetails = await webtmsBackend.getTicketDetails(this.$route.query.tid);
            if(ticketDetails) {
                for(let rpt of ticketDetails.Ticket_Reports) {
                    rpt.created = moment(rpt.created).format('MM/DD/YYYY hh:mm:ss A');
                }
                for(let response of ticketDetails.Ticket_Responses) {
                    if(response.locator === '{00000000-0000-0000-0000-000000000000}') {
                        response.locator_account = 'Un-Assigned';
                    } else {
                        let users = this.$store.getters.companyUsers;
                        let user = users.find(u => {
                            return guidEqual(u.uid, response.locator);
                        });
                        if(user){
                            response.locator_account = user.account;
                        }
                    }
                }
                this.$store.commit('SET_TICKET_DETAILS', ticketDetails);
                if(document && document.title) {

                    const formatAddress = function(address, street, place, state, cross1, cross2) {
                        // https://norfield.atlassian.net/browse/CWTM-902
                        // If address then do "address street, place, state"
                        // If address zero length string do "street & cross1, place, state"
                        // If address zero length string and cross2 do "street between cross1 & cross2, place, state"
                        if(address.length) {
                            return address + ' ' + street + ', ' + place + ', ' + state;
                        }
                        if(cross1?.length) {
                            if(cross2?.length) {
                                // If address zero length string and cross2 do "street between cross1 & cross2, place, state"
                                return `${street} between ${cross1} & ${cross2}, ${place}, ${state}`;
                            } else {
                                // If address zero length string do "street & cross1, place, state"
                                return `${street} & ${cross1}, ${place}, ${state}`;
                            }
                        } else {
                            return street + ', ' + place + ', ' + state;
                        }
                    };

                    const t = this.getTicketDetails.Tickets;
                    document.title = 'Ticket ' + formatTicketNumber(t.ticket, t.revision) + ' ' + t.priority + ' ' + t.type + ' ' +
                        formatAddress(t.address, t.street, t.place, t.state, t.cross1, t.cross2);
                }
            }
        },
        updateSelectedTicketText(newValue) {
            this.selectedTicketText = newValue;
        },
        printCopy() {
            const __TICKET__ = this.$store.getters.ticketDetails;
            // window.print();
            var html = [];
            html.push('<!DOCTYPE html>');
            html.push('<html>');
            html.push('<head>');
            html.push('<title>' + formatTicketNumber(__TICKET__.Tickets.ticket, __TICKET__.Tickets.revision) + '</title>');

            let styleText = `
pre { margin: 0px; word-wrap: break-word; }
table.responses { width: 6in; }
table.responses td.code { font-size: small; }
table.responses td.stage { font-size: small; }
table.responses thead th, table.responses tfoot th { text-align: center; border-bottom: 1px solid var(--ll-border); margin-bottom: 2px; }
table.responses tbody th { text-align: left; }
table.responses tbody [colspan] { border-left: 2px solid silver; padding-left: 6px; font-size: small; }
@media print {
    html,body{height:100%;width:100%;margin:0;padding:0;}
    @page 
    {
        size: letter portrait;
        max-height:99%;
        max-width:99%
    }
    img 
    {
        max-width:100%;
        display:block;
	}
}
`;

            html.push('<style>');
            html.push(styleText);
            html.push('</style>');

            html.push('</head>');
            html.push('<body>');
            html.push('<pre>');
            html.push(htmlEncode(this.selectedTicketText.subject));
            html.push('\r\n\r\n');
            html.push(htmlEncode(this.selectedTicketText.ticket_body));
            html.push('\r\n');
            html.push('</pre>');
            try {
                var canvas = document.getElementById('map').getElementsByTagName('canvas')[0];
                var img = canvas.toDataURL('image/png');
                html.push('<img src="' + img + '"/ id="showMap" style="border:1px solid grey" onclick="document.getElementById(\'showMap\').parentNode.removeChild(document.getElementById(\'showMap\'))">');
            } catch (e) {
                console.log(e);
            }
            html.push('<script>' + 'setTimeout(function() { if(window && window.print) window.print(); }, 100);');
            html.push('</'); html.push('script>');
            html.push('</body>');
            html.push('</html>');
            console.log(html.join(''));
            var myWindow = window.open('', '_blank', '');
            myWindow.document.write(html.join(''));
        },
        formatTicketNumber(tkt,rev) {
            return formatTicketNumber(tkt,rev);
        },
        formateDate(date) {
            return moment(date).format('DD MMM YYYY, hh:mm a');
        },       
        backTicketList() {
            this.$store.commit('SET_TICKET_DETAILS', null);
            this.$router.push({ path: '/tickets' });
        },
        dueDateText(duedate) {
            const now = new Date();
            if (duedate) {
                const d = Date.parse(duedate);
                if (d <= now) {
                    return 'Overdue';
                }
                const diff = d - now;
                const hr = 1 + Math.floor(diff / 3600000);
                return '<' + hr + 'Hr';
            }
            return '?UNKNOWN';
        },
        onChangeExpansionPanel() {
            // ignore updates when in Mobile mode
            if(this.$vuetify.breakpoint.xs) {
                return;
            }
            // update userOption TICKET_DETAIL_LAYOUT_STATE locally
            const TICKET_DETAIL_LAYOUT_STATE = 'UI:TICKET_DETAIL_LAYOUT_STATE';
            let newState = [... this.openedPanels].sort();
            let value_TICKET_DETAIL_LAYOUT_STATE = JSON.stringify(newState).replace('[','').replace(']','');
            let updatedUserOptions = this.getUserOptions.map(item => {
                if(item.option === TICKET_DETAIL_LAYOUT_STATE) {
                    item.value = value_TICKET_DETAIL_LAYOUT_STATE;
                }
                return item;
            });
            this.$store.commit('SET_USER_OPTIONS', updatedUserOptions);
            // update userOption TICKET_DETAIL_LAYOUT_STATE on server
            webtmsBackend.setUserOptions([[TICKET_DETAIL_LAYOUT_STATE, value_TICKET_DETAIL_LAYOUT_STATE]]);
        },
        async updateOrder(event, items) {
            let updatedItems = [0, ...items];
            let getUserOptions = this.getUserOptions.map(item => {
                if(item.option === 'UI:TICKET_DETAIL_LAYOUT_ORDER') {
                    item.value = updatedItems.join(',');
                }
                return item;
            });
            let response = await webtmsBackend.setUserOptions([['UI:TICKET_DETAIL_LAYOUT_ORDER', updatedItems.join(',')]]);
            if(response.set) {
                if(response.set.length > 0) {
                    this.$store.commit('SET_USER_OPTIONS', getUserOptions);
                }
            }
            // the expansion state array will change when panels are moved around, so also save that
            setTimeout(this.onChangeExpansionPanel, 10);
        },
        closeAllPanels() {
            console.error('**** closeAllPanels ****');
            this.openedPanels = [];
        },
        reopen() {
            this.showTicketsReopenDialog = true;
        },
        closeReopen() {
            this.showTicketsReopenDialog = false;
        },
        reopenSuccess() {
            this.loadTicketDetails();
            this.closeReopen();
        },
        respond() {
            this.showTicketsResponseDialog = true;
            this.respondResult = {};
        },
        closeRespond() {
            this.showTicketsResponseDialog = false;
        },
        responseSuccess(result) {
            this.updateTicket(result);
            this.closeRespond();
            if(result.errors) {
                this.respondResult = result;
                this.showRespondError = true;
            }
        },
        closeRespondErrorDialog() {
            this.showRespondError = false;
            this.respondResult = {};
        },
        offlineResponseSuccess() {
            this.closeRespond();
            this.showResponseToast = true;
        },
        updateTicket(result) {
            for(let ticket of result.tickets) {
                if(ticket.result.result !== 'OK') {
                    console.error('updateTicket failed with error ', ticket.result);
                }
            }
            this.loadTicketDetails();
        },
        assign() {
            this.showTicketsAssignDialog = true;
        },
        closeAssign() {
            this.showTicketsAssignDialog = false;
        },
        assignSuccess(result) {
            this.updateTicket(result);
            this.closeAssign();
        },
        formatPhone(phone) {
            if(phone) {
                return formatPhone(phone);
            }
            return phone;
        },        
        showExplosives(explosives) {
            // Possible values: Y, U, N, ?
            if(explosives === 'Y') {
                return true;
            } else {
                return false;
            }
        },        
        getExplosivesColor() {
            // Possible values: Y, U, N, ?
            return this.default_color;
        },
        getDefaultColor() {
            return this.default_color;
        },
        showVacuum(vacuum) {
            // Possible values: Y, N, ?
            if(vacuum === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getVacuumColor() {
            // Possible values: Y, N, ?
            return this.default_color;
        },  
        showBoring(boring) {
            // Possible values: D, H, Y, N, ? // Unknown what D and H mean 
            if(boring === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getBoringColor() {
            // Possible values: D, H, Y, N, ? // Unknown what D and H mean  
            return this.default_color;
        },   
        showMeet(meet) {
            // Possible values: Y, N, ? 
            if(meet === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getMeetColor() {
            return this.default_color;
        },     
        showLegal(legal) {
            // Possible values: Y, N, ?
            //  Note: Legal value of N is what we want to alert the user to  
            if(legal === 'N') {
                return true;
            } else {
                return false;
            }
        },
        getLegalColor(legal) {
            // Possible values: Y, N, ?  
            if(legal === 'N') {
                return 'red';
            } else {
                return this.default_color;
            }
        },
        showRemark(remark) {
            // Possible values: Y, N, ?  
            if(remark === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getRemarkColor() {
            // Possible values: Y, N, ?  
            return this.default_color;
        },
        showExtendedJob(extendedJob) {
            // Possible values: Y, N, ?  
            if(extendedJob === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getExtendedJobColor() {
            // Possible values: Y, N, ?  
            return this.default_color;
        },
        showNight(night) {
            // Possible values: Y, N, ?  
            if(night === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getNightColor() {
            // Possible values: Y, N, ?  
            return this.default_color;
        },
        showWeekend(weekend) {
            // Possible values: Y, N, ?  
            if(weekend === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getWeekendColor() {
            // Possible values: Y, N, ?  
            return this.default_color;
        },     
        showExcavStSidewalk(excavStSidewalk) {
            // Possible values: Y, N, ?  
            if(excavStSidewalk === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getExcavStSidewalkColor() {
            // Possible values: Y, N, ?  
            return this.default_color;
        },      
        showDigInRoad(digInRoad) {
            // Possible values: Y, N, ?  
            if(digInRoad === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getDigInRoadColor() {
            // Possible values: Y, N, ?  
            return this.default_color;
        },
        showOneYear(oneYear) {
            // Possible values: Y, N, ?  
            if(oneYear === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getOneYearColor() {
            // Possible values: Y, N, ?  
            return this.default_color;
        },
        showPremarked(delineated,whitelined){
            // Possible values for delineated: Y, N, ?
            // Possible values for whitelined: Y, N, ?
            if(delineated === 'Y' || whitelined === 'Y') {
                return true;
            } else {
                return false;            
            }          
        },
        getPremarkedColor(){
            // Possible values for delineated: Y, N, ?
            // Possible values for whitelined: Y, N, ?
            return this.default_color;
        },
        showRailroad(railroad) {
            // Possible values: Y, N, U, ?
            if(railroad === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getRailroadColor() {
            // Possible values: Y, N, U, ?
            return this.default_color;
        },
    }
};
</script>
<style>
    #tickets-details-page {
        color: inherit;
    }
    #tickets-details-page .v-toolbar__content {
        padding: 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .tickets-details-offline-header {
        display: flex;
        flex: 1 1 auto;
        background-color: var(--ll-surface-warning);
        height: 44px;
        justify-content: center;
        align-items: center;
    }
    #tickets-details-page .v-expansion-panel {
        margin-bottom: 8px;
        transition: none !important;
    }
    #tickets-details-page .v-expansion-panel--active:not(:first-child),
    #tickets-details-page .v-expansion-panel--active + .v-expansion-panel {
        margin-top: 0px !important;
    }
    #tickets-details-page .v-expansion-panel-header,
    #tickets-details-page .v-expansion-panel-header--active {
        height: 48px;
        min-height: 48px !important;
        padding: 0px 8px;
        background: rgba(128, 128, 128, .1);
        border-radius: 4px 4px 0px 0px;
        color: inherit;
        margin: 0px 0px;
    }
    #tickets-details-page .v-expansion-panel-header > *:not(.v-expansion-panel-header__icon) {
        flex: inherit !important;
    }
    #tickets-details-page .v-expansion-panel-header .expansion-title-icon {
        flex: inherit !important;
        position: absolute;
        left: 16px;
    }
    #tickets-details-page .v-expansion-panel-header .expansion-title {
        margin-left: 35px;
    }
    .custom-data-table {
        font-size: 12px;
    }
    .custom-data-table tbody {
        vertical-align: baseline;
    }
    .custom-data-table td:last-child {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
        letter-spacing: 0.004em;
        color: inherit;
    }
    .custom-data-table td:first-child {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 20px;
        letter-spacing: 0.004em;
        color: inherit;
        opacity: .7;
        width: 100px;
    }
    .detail-chip {
        border-radius: 20px !important;
        height: 20px !important;
        padding:4px 4px !important;
        margin: 1px !important;       
    }    
    #tickets-details-page .v-expansion-panel-content {
        margin: 0px;
    }
    #tickets-details-page .v-expansion-panel-content__wrap {
        padding: 0px !important;
    }

    .ticket-status-open {
        color: green !important;
        border: 1px solid green !important;
    }
    .ticket-status-closed {
        color: #AAAAAA !important;
        border: 1px solid #AAAAAA !important;
    }
    .ticket-status-loading {
        color: #FFFF00 !important;
        border: 1px solid #FFFF00 !important;
    }
    .ticket-status-unknown {
        color: #f80909 !important;
        border: 1px solid #f80909 !important;
    }
    #tickets-details-page .v-expansion-panels {
        display: block !important;
    }

    .theme--dark #tickets-details-page .v-data-table {
        border-color: rgba(255, 255, 255, .2) !important;
    }
    .theme--dark #tickets-details-page .v-data-table .v-data-table-header th {
        background: #272727 !important;
        color: rgba(255, 255, 255, .7) !important;
    }
    .theme--dark #tickets-details-page .v-data-table tbody td {
        background: #1E1E1E !important;
        color: rgba(255, 255, 255, .87) !important;
    }
    .theme--dark #tickets-details-page .responses-container {
        background: #1E1E1E !important;
        color: rgba(255, 255, 255, .87);
    }
    .theme--dark #tickets-details-page .responses-container .offline-response-row,
    .theme--dark #tickets-details-page .offline-image {
        background-color: rgba(244, 67, 54, .12) !important;
    }
    .theme--dark #tickets-details-page .ticket-card-header {
        background-color: #272727 !important;
    }
    .theme--dark #tickets-details-page .ticket-card-info,
    .theme--dark #tickets-details-page .ticket-details,
    .theme--dark #tickets-details-page .reports-ticket-container,
    .theme--dark #tickets-details-page .cutom-body,
    .theme--dark #tickets-details-page .ticket-response-details td {
        border-color: rgba(255, 255, 255, .2) !important;
        color: rgba(255, 255, 255, .87) !important;
    }
    .theme--dark #tickets-details-page .ticket-card-ticket-revision a,
    .theme--dark #tickets-details-page .action-btn .v-btn__content {
        color: var(--v-primary-base) !important;
    }
    .theme--dark #tickets-details-page .no-img-text {
        color: rgba(255, 255, 255, .6) !important;
    }
    .theme--dark #tickets-details-page .mobile-view-add-note,
    .theme--dark #tickets-details-page .mobile-view-images,
    .theme--dark #tickets-details-page .upload-btn-xs {
        background: #1E1E1E !important;
        border-color: rgba(255, 255, 255, .2) !important;
        box-shadow: 0 0 6px 1px rgba(0, 0, 0, .45) !important;
    }

    .expandable-mobile-view {
        position: fixed;
        z-index: 9 !important;
        background: inherit;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        overflow: auto;
    }
    .mobile-view-header {
        display: flex;
        align-items: center;
        padding: 16px;
        border-bottom: 1px solid #545252 !important;
        box-shadow: 0px 0px 9px -3px black !important;
        z-index: 10;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
    }
    .expandable-mobile-view .container {
        margin-top: 65px !important;
    }
    .mobile-footer-controls {
        position: fixed;
        bottom: 0;
        z-index: 6;
        background: inherit;
        left: 0;
        right: 0;
        padding: 8px;
    }
    .mobile-footer-controls div {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .mobile-footer-controls div button {
        width: 45%;
    }
    .mobile-footer-controls.offline div button {
        width: 80%;
    }
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }   
</style>
